(function ($) {

  const EDITING_MODE_CLASS = 'editing-mode';

  $(document).ready(function () {
    const editBtn = $('#editBtn');
    const cancelBtn = $('#cancelBtn');
    const form = $('#accountForm');
    const contentWrapper = $('.content-wrapper');
    const profilePictureInput = $('#profilePictureInput');
    const profilePreview = $('#profilePreview');
    const removeProfilePicture = $('#removeProfilePicture');

    // Read PHP-provided values from data attributes — no inline PHP needed
    const defaultAvatar = form.data('default-avatar');
    const nonce = form.data('nonce');
    const hadImageOnLoad = form.data('has-image') === 1;

    let originalProfileSrc = profilePreview.attr('src');
    let profilePictureRemoved = false;
    let profilePictureFile = null;

    // ---------------------------------------------------------------------------
    // Profile picture — preview on file select
    // ---------------------------------------------------------------------------
    profilePictureInput.on('change', function (e) {
      const file = e.target.files[0];
      if (!file) { return; }

      const allowedTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'image/gif',
      ];
      if (!allowedTypes.includes(file.type)) {
        alert('Please upload a valid image file (JPG, PNG, or GIF)');
        profilePictureInput.val('');
        return;
      }

      const maxSize = 5 * 1024 * 1024; // 5 MB
      if (file.size > maxSize) {
        alert('File size must be less than 5MB');
        profilePictureInput.val('');
        return;
      }

      profilePictureFile = file;

      const reader = new FileReader();
      reader.onload = function (event) {
        profilePreview.attr('src', event.target.result);
        removeProfilePicture.show();
        profilePictureRemoved = false;
      };
      reader.readAsDataURL(file);
    });

    // ---------------------------------------------------------------------------
    // Profile picture — remove
    // ---------------------------------------------------------------------------
    removeProfilePicture.on('click', function (e) {
      e.preventDefault();
      if (!confirm('Are you sure you want to remove your profile picture?')) {
        return;
      }

      profilePictureRemoved = true;
      profilePictureInput.val('');
      profilePictureFile = null;
      profilePreview.attr('src', defaultAvatar);
      $(this).hide();
    });

    // ---------------------------------------------------------------------------
    // Edit / cancel toggle
    // ---------------------------------------------------------------------------
    editBtn.on('click', function () {
      if (contentWrapper.hasClass(EDITING_MODE_CLASS)) {
        contentWrapper.removeClass(EDITING_MODE_CLASS);
        editBtn.removeClass('editing');
        editBtn.children('span').text('Edit');
      } else {
        contentWrapper.addClass(EDITING_MODE_CLASS);
        editBtn.addClass('editing');
        editBtn.children('span').text('Editing');
        // Snapshot the current avatar so cancel can restore it
        originalProfileSrc = profilePreview.attr('src');
      }
    });

    cancelBtn.on('click', function () {
      contentWrapper.removeClass(EDITING_MODE_CLASS);
      editBtn.removeClass('editing');
      editBtn.children('span').text('Edit');
      form[0].reset();
      profilePictureInput.val('');
      profilePictureFile = null;
      profilePictureRemoved = false;
      profilePreview.attr('src', originalProfileSrc);

      // Restore remove-button visibility to match the server-side state
      if (hadImageOnLoad) {
        removeProfilePicture.show();
      } else {
        removeProfilePicture.hide();
      }
    });

    // ---------------------------------------------------------------------------
    // Form submit
    // ---------------------------------------------------------------------------
    form.on('submit', function (e) {
      e.preventDefault();
      $('#loading').addClass('d-flex');

      const formData = new FormData();
      formData.append('action', 'update_account_details');
      formData.append('nonce', nonce);

      // Collect all editable text / email / tel / url inputs
      $(this)
        .find(
          'input[type="text"], input[type="email"], input[type="tel"], input[type="url"]',
        )
        .each(function () {
          const name = $(this).attr('name');
          if (name) {
            formData.append(name, $(this).val());
          }
        });

      // Profile picture handling
      if (profilePictureRemoved) {
        formData.append('remove_profile_picture', '1');
      } else if (profilePictureFile) {
        formData.append('user_image', profilePictureFile);
      } else {
        // No profile picture change — nothing to append.
      }

      if (typeof ajax_callback_data !== 'undefined') {
        $.ajax({
          url: ajax_callback_data.ajax_url,
          type: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          success: function (response) {
            if (response.success) {
              window.scrollTo({ top: 0 });
              location.reload();
            } else {
              alert(
                response.data.message ||
                  'Error updating account details. Please try again.',
              );
              $('#loading').removeClass('d-flex');
            }
          },
          error: function (xhr, status, error) {
            console.error('AJAX Error:', error);
            console.error('Response:', xhr.responseText);
            alert('Error updating account details. Please try again.');
            $('#loading').removeClass('d-flex');
          },
        });
      }
    });
  });
})(jQuery);
